import { useFaqWidget } from "../../../providers/context";
import { useWidgetApp } from "~/provider";
import { Show } from "solid-js";
import { FaqRootDesktop } from "./desktop";
import { FaqRootMobile } from "./mobile";

export function Root() {

	const { screen } = useWidgetApp();
	const { faqName } = useFaqWidget();

	return (
		<Show 
			when={screen() === "desktop"}
			fallback={<FaqRootMobile name={faqName()} />}
		>
			<FaqRootDesktop name={faqName()} />
		</Show>
	);
}